import React, { useState, useEffect } from 'react';
import { ArrowRight } from 'lucide-react';

const Solution = () => {
  const [activeMenu, setActiveMenu] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);

  // Content for each menu based on PDF
  const menuContent = [
    {
      title: "Next Gen Technology",
      content: "MAXIOM'S MODELS & ALGORITHMS UTILISE INSTITUTIONAL GRADE STRATEGIES TO MANUFACTURE SOLUTIONS"
    },
    {
      title: "Dedicated Advisor",
      content: "MAXIOM'S MODELS & ALGORITHMS UTILISE INSTITUTIONAL GRADE STRATEGIES TO MANUFACTURE SOLUTIONS"
    },
    {
      title: "Institutional Strategies",
      content: "MAXIOM'S MODELS & ALGORITHMS UTILISE INSTITUTIONAL GRADE STRATEGIES TO MANUFACTURE SOLUTIONS"
    }
  ];

  // Handle menu change
  const handleMenuChange = (index) => {
    if (activeMenu === index) return;
    
    setIsTransitioning(true);
    setTimeout(() => {
      setActiveMenu(index);
      setIsTransitioning(false);
    }, 500);
  };

  // Auto-rotate menus with continuous looping
  useEffect(() => {
    const menuInterval = setInterval(() => {
      const nextIndex = (activeMenu + 1) % menuContent.length;
      handleMenuChange(nextIndex);
    }, 5000); // Change menu every 5 seconds

    return () => clearInterval(menuInterval);
  }, [activeMenu]);

  return (
    <div className="w-full max-w-6xl mx-auto bg-white shadow-xl rounded-lg overflow-hidden">
      {/* Content area with website-style layout */}
      <div className="flex flex-col md:flex-row pt-36">
        {/* Menu Column (Left Side) */}
        <div className="w-full md:w-72 bg-gray-50">
          {menuContent.map((menu, index) => (
            <button
              key={index}
              className={`w-full text-left py-6 px-6 font-medium transition-all duration-300 border-l-4 ${
                activeMenu === index
                  ? 'bg-blue-50 text-blue-800 border-blue-600'
                  : 'bg-transparent text-gray-700 border-transparent hover:bg-gray-100'
              }`}
              onClick={() => handleMenuChange(index)}
            >
              <div className="flex items-center justify-between">
                <span>{menu.title}</span>
                {activeMenu === index && <ArrowRight size={18} className="text-blue-600" />}
              </div>
            </button>
          ))}
        </div>

        {/* Content Area (Right Side) */}
        <div className="flex-1 p-10 flex items-center justify-center bg-gradient-to-br from-white to-blue-50 min-h-80">
          <div 
            className={`transition-all duration-700 transform ${
              isTransitioning ? 'opacity-0 translate-y-4' : 'opacity-100 translate-y-0'
            }`}
          >
            <h2 className="text-3xl font-bold mb-6 text-gray-800 border-b-2 border-blue-500 pb-2 inline-block">
              {menuContent[activeMenu].title}
            </h2>
            <p className="text-xl text-gray-700 max-w-2xl leading-relaxed">
              {menuContent[activeMenu].content}
            </p>
          </div>
        </div>
      </div>
      
      {/* Progress bar for timing visualization */}
      <div className="h-1 bg-gray-200 w-full">
        <div 
          className="h-full bg-blue-600 transition-all duration-100 ease-linear"
          style={{ 
            width: `${(activeMenu / (menuContent.length - 1)) * 100}%`,
            transitionProperty: 'width'
          }}
        />
      </div>
    </div>
  );
};

export default Solution;